export const maskPhone = (phoneNumber: string) => {
  return phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

export const formatCurrency = (num: any) => {
    if (num === null || num === undefined) {
        return "";
    }

    return '$' + (num ?? 0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
